import Fetch from 'fetch';

export default {
    getLocale() {
        return Fetch.get('/site-olb/v1/locale');
    },
};
